import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';

import SEO from '../components/SEO';
import '../styles/Auth.css';

const LinkDiscordPage = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('checking');
  const [errorMsg, setErrorMsg] = useState('');
  const [discordUsername, setDiscordUsername] = useState('');
  const [bonusGb, setBonusGb] = useState(0);

  const token = new URLSearchParams(location.search).get('token');

  useEffect(() => {
    if (authLoading) return;

    if (!token) {
      setStatus('error');
      setErrorMsg('No link token provided. Please use the /auth command in Discord.');
      return;
    }

    if (!isAuthenticated) {
      navigate('/login', {
        state: { from: { pathname: '/link-discord', search: location.search } },
        replace: true,
      });
      return;
    }

    const linkAccount = async () => {
      setStatus('linking');

      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) {
          setStatus('error');
          setErrorMsg('Session expired. Please log in again.');
          return;
        }

        const response = await fetch(
          `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/link-discord`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${session.access_token}`,
              'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            },
            body: JSON.stringify({ token }),
          }
        );

        const result = await response.json();

        if (result.success) {
          setDiscordUsername(result.discord_username);
          setBonusGb(result.bonus_gb || 0);
          setStatus('success');
        } else {
          setStatus('error');
          setErrorMsg(result.error || 'Failed to link accounts. Please try again.');
        }
      } catch (err) {
        setStatus('error');
        setErrorMsg('Connection error. Please try again.');
      }
    };

    linkAccount();
  }, [authLoading, isAuthenticated, token, navigate, location.search]);

  return (
    <div className="auth-page">
      <SEO title="Link Discord" path="/link-discord" noindex={true} />
      <div className="auth-left">
        <div className="auth-logo">
          <Link to="/" className="auth-logo-link">
            <img src="/pathproxy.png" alt="PathProxy Logo" className="auth-logo-image" />
            <span className="brand-name">pathproxy</span>
          </Link>
        </div>

        <div className="auth-form-container">
          {(status === 'checking' || status === 'linking') && (
            <div className="success-message">
              <div className="btn-spinner" style={{ width: '48px', height: '48px', margin: '0 auto 24px' }}></div>
              <h1>Linking Discord...</h1>
              <p>Please wait while we connect your accounts.</p>
            </div>
          )}

          {status === 'success' && (
            <div className="success-message">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <h1>Discord Linked!</h1>
              <p>Your Discord account <strong>{discordUsername}</strong> has been linked to your PathProxy account.</p>
              {bonusGb > 0 && (
                <p style={{ color: '#E8FF00', marginTop: '12px' }}>You received <strong>{bonusGb} GB</strong> free Residential Basic bandwidth!</p>
              )}
              <Link to="/dashboard" className="auth-submit-btn" style={{ display: 'inline-block', textDecoration: 'none', marginTop: '20px' }}>
                Go to Dashboard
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div className="success-message">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ff4444" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <h1>Linking Failed</h1>
              <p>{errorMsg}</p>
              <Link to="/dashboard" className="auth-submit-btn" style={{ display: 'inline-block', textDecoration: 'none', marginTop: '20px' }}>
                Go to Dashboard
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="auth-right">
      </div>
    </div>
  );
};

export default LinkDiscordPage;
